module.exports = __webpack_public_path__ + "img/categorie-nos-prestations-famille-boutrais-medium.29d74964.jpg";